import { FuncData, NO_PERMISSIONS, User } from '@interfaces';

export const EMPTY_DATA: FuncData = {

	asOfUtc: 0,
	user: {} as User,
	staff: [],
	permissions: NO_PERMISSIONS,
	trimesters: [],

};